export const INTEGRATIONS_PATH_NAME = 'integrations';
export const WIZ_PATH_NAME = 'wiz';
export const WIZ_INTEGRATION_PATH_NAME = `security/${WIZ_PATH_NAME}`;
export const WIZ_WEBHOOKS_PATH_NAME = `webhooks/${WIZ_PATH_NAME}`;
export const HACKERONE_PATH_NAME = 'hackerone';
export const HACKERONE_INTEGRATION_PATH_NAME = `security/${HACKERONE_PATH_NAME}`;
export const HACKERONE_WEBHOOKS_PATH_NAME = `webhooks/${HACKERONE_PATH_NAME}`;
export const XPANSE_PATH_NAME = 'xpanse';
export const XPANSE_INTEGRATION_PATH_NAME = `security/${XPANSE_PATH_NAME}`;
export const CROWDSTRIKE_PATH_NAME = 'crowdstrike';
export const CROWDSTRIKE_INTEGRATION_PATH_NAME = `security/${CROWDSTRIKE_PATH_NAME}`;
export const BUGCROWD_PATH_NAME = 'bugcrowd';
export const BUGCROWD_INTEGRATION_PATH_NAME = `security/${BUGCROWD_PATH_NAME}`;
export const BUGCROWD_WEBHOOKS_PATH_NAME = `webhooks/${BUGCROWD_PATH_NAME}`;
export const JENKINS_PATH_NAME = 'jenkins';
export const JENKINS_WEBHOOKS_PATH_NAME = `webhooks/${JENKINS_PATH_NAME}`;
export const JENKINS_INTEGRATION_PATH_NAME = `ci-cd/${JENKINS_PATH_NAME}`;
export const UPWIND_PATH_NAME = 'upwind';
export const UPWIND_INTEGRATION_PATH_NAME = `security/${UPWIND_PATH_NAME}`;
export const SIEM_PATH_NAME = 'siem';
export const SIEM_INTEGRATION_PATH_NAME = SIEM_PATH_NAME;
export const TORQ_PATH_NAME = 'torq';
export const TORQ_INTEGRATION_PATH_NAME = `automation/${TORQ_PATH_NAME}`;
export const PREVENTION_PATH_NAME = 'prevention';
export const PREVENTION_INTEGRATION_PATH_NAME = PREVENTION_PATH_NAME;
export const CLOUD_PATH_NAME = 'cloud';
export const CLOUD_INTEGRATION_PATH_NAME = CLOUD_PATH_NAME;

export const INTEGRATION_TYPES = {
  SERVICENOW: 'servicenow',
  JIRA: 'jira',
  LINEAR: 'linear',
  GITHUB_ISSUES: 'github_issues',
  WIZ: WIZ_PATH_NAME,
  HACKERONE: HACKERONE_PATH_NAME,
  XPANSE: XPANSE_PATH_NAME,
  CROWDSTRIKE: CROWDSTRIKE_PATH_NAME,
  CROWDSTRIKE_NG_SIEM: 'crowdstrikeNgSiem',
  CORTEX_XSIAM: 'cortexXsiam',
  BUGCROWD: BUGCROWD_PATH_NAME,
  UPWIND: UPWIND_PATH_NAME,
  NOVA: 'nova',
  JENKINS: JENKINS_PATH_NAME,
  SLACK: 'slack',
  MICROSOFT_TEAMS: 'microsoftTeams',
  PAGERDUTY: 'pagerduty',
  CONFLUENCE: 'confluence',
  TORQ: TORQ_PATH_NAME,
  SPLUNK: 'splunk',
  NOTION: 'notion',
  AZURE_DEVOPS: 'azureDevOps',
  GITHUB: 'github',
  GITLAB: 'gitlab',
  BITBUCKET: 'bitbucket',
  GLEAN: 'glean',
  GENERIC_WAF: 'genericWaf',
  AWS_SECURITY_GROUP: 'awsSecurityGroup',
  GCP_FIREWALL: 'gcpFirewall',
  AZURE_NSG: 'azureNsg',
  GENERIC_CONFIG: 'genericConfig',
  GENERIC_IPS: 'genericIps',
  AWS: 'aws',
  GCP: 'gcp',
  AZURE: 'azure',
  MISCONFIG_RESEARCHER: 'misconfigResearcher',
} as const;

export type IntegrationType =
  (typeof INTEGRATION_TYPES)[keyof typeof INTEGRATION_TYPES];
